module.exports = __webpack_public_path__ + "static/mastodon-305492c324c72d69a27ff51d1fd31fae.png";